import geoHierarchyLevels from '../../geoHierarchyLevels.js';

const titles = {
  [geoHierarchyLevels.STREET]: 'Weitere Adressen und Immobilienpreise in der Umgebung entdecken',
  [geoHierarchyLevels.DISTRICT]: 'Weitere Straßen und Immobilienpreise in der Umgebung entdecken',
  [geoHierarchyLevels.CITY]: 'Weitere Bezirke/Gemeinden und Immobilienpreise in der Umgebung entdecken',
  [geoHierarchyLevels.REGION]: 'Weitere Städte und Immobilienpreise in der Umgebung entdecken',
};

const getTitleFor = (hierarchyLevel) => titles[hierarchyLevel] || '';

export default {
  getTitleFor,
};
